import * as React from 'react';
import { Device } from '../Device';
import { MobileSlider } from './MobileSlider';
import { DesktopSlider } from './DesktopSlider';
import { IScrollToSlideParams, ISliderProps, ISlider } from './types';

interface ISliders {
  [sliderId: string]: ISlider;
}

export class Slider extends React.Component<ISliderProps, {}> {
  private static sliders: ISliders = {};
  private sliderRef = React.createRef<ISlider>();

  public static scrollToSlide = (sliderId: string, slide: number, params?: IScrollToSlideParams) => {
    const slider = Slider.sliders[sliderId];

    if (slider) {
      slider.scrollToSlide(slide, params);
    }
  }

  public componentDidMount() {
    const { id } = this.props;
    const slider = this.sliderRef.current;

    if (id && slider) {
      Slider.sliders[id] = slider;
    }
  }

  public componentWillUnmount() {
    const { id } = this.props;

    if (id) {
      delete Slider.sliders[id];
    }
  }

  public render() {
    const {
      children,
      additionalOffset,
      animationTime,
      initialSlide,
      indents,
      slideWidth,
      step,
      visibleSlides,
      onScrollLeft,
      onScrollRight,
    } = this.props;

    const mobileProps = {
      ref: this.sliderRef as React.RefObject<MobileSlider>,
      children,
      initialSlide,
      indents,
      onScrollLeft,
      onScrollRight,
      slideWidth,
    };

    const desktopProps = {
      ref: this.sliderRef as React.RefObject<DesktopSlider>,
      children,
      initialSlide,
      indents,
      onScrollLeft,
      onScrollRight,
      visibleSlides,
      step,
      animationTime,
      additionalOffset,
    };

    return <Device mobile={<MobileSlider {...mobileProps} />} desktop={<DesktopSlider {...desktopProps} />} />;
  }
}
